import React, { Component } from 'react';
import { observer } from 'mobx-react';
import DataWrapper from '../../../principal/containers/DataWrapper';
import Footer from "../../../comum/components/Footer";
import FooterContent from '../../../comum/components/FooterContent';
import FiltrosAgServico from "../components/FiltrosAgServicos";
import { TabelaAgServico } from "../components/TabelaAgServicos";
import { Row, Col, Button, Container } from "reactstrap";
import FooterOptions from '../../../comum/components/FooterOptions';
import IconButton from '../../../comum/components/IconButton';
import ExportarExcelAgServicos from '../components/ExportarExcelAgServicos';
import { makePDF } from '../../../../utils/formatar';
import AgServicosVisualizarStore from '../stores/AgServicosVisualizarStore';
import ModalForm from '../../../comum/components/ModalForm';
import ModalAviso from '../../../comum/components/ModalAviso';
import LoadingImage from '../../../comum/components/LoadingImage';
import { ComboSelectList } from '../../../comum/components/ComboSelectList';

@DataWrapper
@observer
export class AgServicosVisualizar extends Component {
    constructor(props) {
        super(props);

        this.controller = new AgServicosVisualizarStore(this.props.service);
        this.controllerAgServicos = this.props.controller;
    };

    modalQuantidadeContainer = () => {
        let msg = "";
        if (!this.controller.containersDoModalQuantidade || this.controller.containersDoModalQuantidade.length>=1)
            msg = "encontrado";
        else
            msg = "encontrados";
        return (
            this.controller.containersDoModalQuantidade &&
                <ModalForm
                    className="modal-analise tamanho-modal-700"
                    onClickCancelar={ () => this.controller.containersDoModalQuantidade = false }
                    labelCancelar={<span className="label-primary">FECHAR</span>}
                    esconderSalvar={true} >
                    <h2>Containers do agendamento</h2>

                    <ComboSelectList
                        title=""
                        legthTitle={msg}
                        list={ this.controller.containersDoModalQuantidade }
                        itenList="CodCntr">
                    </ComboSelectList>
                </ModalForm>    
        );
    }

    componentDidMount() {
        // this.controller.listarAgendamentos(); // TODO Remover
    };

    modalBuscaTicketVGM() {
        if(this.controller.loadingTicketVGM) {
            return (
                <ModalAviso
                    onClickFechar={() => {this.controller.loadingTicketVGM = false}}
                >
                    <h2>
                        Processando
                    </h2>
                    <LoadingImage />
                </ModalAviso>
            )
        }
    }

    render() {
        const pdfData = this.controller.colunasExportacao;
        const pdfDataTime = pdfData.filter(elem => elem.formatter && elem.formatter.name === 'formatarDataCustomHTML');

        return (
            <div>
                {this.modalQuantidadeContainer()}
                {this.modalBuscaTicketVGM()}
                <div className="form-wrapper">
                    <Container className="liberacao-cabotagem tela-botoes-inclusao-topo" fluid>
                        <Row className="botoes-inclusao-topo">
                            <Col xs={12} sm={12} md={12} >
                                <Button onClick={() => this.props.controller.cadastrar()} className="btn-com-bordas-primary">Novo Agendamento</Button>
                            </Col>
                        </Row>
                        <FiltrosAgServico controller={this.controller} />                        
                        <TabelaAgServico controller={this.controller} controllerAgServicos={this.controllerAgServicos}/>
                    </Container>
                </div>
                <Footer>
                    <FooterContent>
                        {this.controller.total !== null &&
                            <div className="justify-content-between">
                                <div>
                                    <b>{this.controller.total}</b> {this.controller.total === 1 ? 'registro' : 'registros'} -
                                <a onClick={() => this.controller.reListar()}>Atualizar Lista</a>
                                </div>
                            </div>
                        }
                    </FooterContent>
                    <FooterOptions>
                        <div>
                            <IconButton
                                icon="file-pdf"
                                text="Baixar PDF"
                                size="md"
                                disabled={this.controller.items.length === 0}
                                onClick={
                                    () => makePDF(
                                        this.controller.items,
                                        pdfData.map(elem => elem.dataField),
                                        pdfData.map(elem => elem.text),
                                        pdfDataTime.map(elem => elem.dataField),
                                        true,
                                        false,
                                        { qtdColFixo: "A2", nomeDoArquivo: "AgendamentoServico.pdf" }
                                    )
                                }
                            />
                        </div>
                        <div>
                            <ExportarExcelAgServicos controller={this.controller} />
                        </div>
                    </FooterOptions>
                </Footer>
            </div>

        );
    }
}



// WEBPACK FOOTER //
// ./src/modules/agendamentoservicos/visualizar/telas/AgServicosVisualizar.js